/**
 * PaymentProvidersDisconnectSumupController — page
 * /parametres-encaissement-deconnexion-sumup.html (EPIC-045 / 45.5).
 *
 * Page dédiée de confirmation de déconnexion SumUp. Convention
 * `feedback_no_modal_dedicated_edit_page` : pas de modal, page dédiée.
 *
 * Récupère le `?id=<uuid>` du provider, appelle
 * `POST /v1/payment-providers/sumup/{id}/disconnect`, puis redirige
 * vers `/parametres-encaissement-edition.html?id={id}` (l'utilisateur
 * voit l'état non connecté).
 *
 * Erreurs : 404 (provider inexistant ou autre org) → message neutre +
 * lien retour. 5xx ou erreur transport → bannière, garder l'utilisateur
 * sur la page.
 */

import BaseController from "./base_controller.js";
import { api, APIError } from "/js/services/api.js";

export default class PaymentProvidersDisconnectSumupController extends BaseController {
  static targets = ["errorBanner", "confirmBtn"];

  connect() {
    const qs = new URLSearchParams(window.location.search);
    this._providerId = qs.get("id") || "";
    if (this._providerId === "") {
      this._showErrorBanner(
        "Identifiant du connecteur manquant dans l'URL.",
      );
      if (this.hasConfirmBtnTarget) this.confirmBtnTarget.disabled = true;
    }
  }

  async onConfirm(event) {
    if (event) event.preventDefault();
    if (this._providerId === "") return;
    this._hideErrorBanner();
    if (this.hasConfirmBtnTarget) this.confirmBtnTarget.disabled = true;
    try {
      await api.sumup.disconnect(this._providerId);
      window.location.assign(
        `/parametres-encaissement-edition.html?id=${encodeURIComponent(this._providerId)}`,
      );
    } catch (error) {
      if (error instanceof APIError && error.status === 404) {
        this._showErrorBanner("Connecteur SumUp introuvable.");
      } else if (error instanceof APIError && error.message) {
        this._showErrorBanner(error.message);
      } else {
        this._showErrorBanner(
          "Erreur réseau — impossible de déconnecter SumUp.",
        );
      }
      if (this.hasConfirmBtnTarget) this.confirmBtnTarget.disabled = false;
    }
  }

  _showErrorBanner(message) {
    if (!this.hasErrorBannerTarget) return;
    this.errorBannerTarget.textContent = message;
    this.errorBannerTarget.hidden = false;
  }

  _hideErrorBanner() {
    if (!this.hasErrorBannerTarget) return;
    this.errorBannerTarget.hidden = true;
    this.errorBannerTarget.textContent = "";
  }
}
